<template>
  <div class="user-profile">
    <div class="profile-content" v-loading="loading">
      <!-- 整体卡片容器 -->
      <el-card class="main-card">
        <!-- 基本信息区域 -->
        <div class="section basic-info-section">
          <div class="section-header">
            <h3 class="section-title">基本信息</h3>
          </div>
          <div class="basic-info-content">
            <!-- 左侧头像区域 -->
            <div class="avatar-area" @click="handleAvatarClick">
              <el-avatar
                  :size="80"
                  :src="getAvatarUrl()"
                  class="user-avatar"
              />
              <div class="avatar-hint">
                <span class="hint-text">点击更换头像</span>
              </div>
            </div>

            <!-- 右侧信息区域 -->
            <div class="info-area">
              <div class="info-grid">
                <div class="info-row">
                  <div class="info-item">
                    <label class="info-label">账号</label>
                    <span class="info-value">{{ profile.username || '-' }}</span>
                  </div>
                  <div class="info-item">
                    <label class="info-label">昵称</label>
                    <div class="info-with-action">
                      <span class="info-value">{{ profile.nickname || '-' }}</span>
                      <el-button
                          type="primary"
                          link
                          size="small"
                          @click="handleAction('editNickname')"
                          class="edit-btn"
                      >
                        <el-icon><EditPen /></el-icon>
                      </el-button>
                    </div>
                  </div>
                </div>
                <div class="info-row">
                  <div class="info-item">
                    <label class="info-label">账号类型</label>
                    <span class="info-value">{{ profile.userType || '-' }}</span>
                  </div>
                </div>
                <div class="info-row">
                  <div class="info-item">
                    <label class="info-label">账号等级</label>
                    <span class="info-value">
                      <el-tag
                          v-if="profile.userLevel"
                          type="primary"
                          size="small"
                          class="user-level-tag"
                      >
                        {{ profile.userLevel }}
                      </el-tag>
                      <span v-else>-</span>
                    </span>
                  </div>
                  <div class="info-item">
                    <label class="info-label">联系手机</label>
                    <div class="info-with-action">
                      <span class="info-value">{{ profile.phone || '-' }}</span>
                      <el-button
                          type="primary"
                          link
                          size="small"
                          @click="handleAction('modify')"
                      >
                        修改
                      </el-button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- 分隔线 -->
        <div class="section-divider"></div>

        <!-- 登录方式区域 -->
        <div class="section login-methods-section">
          <div class="section-header">
            <div class="section-title-with-subtitle">
              <h3 class="section-title">登录方式</h3>
              <span class="section-subtitle">账号支持多种登录方式，便捷管理账号</span>
            </div>
          </div>
          <div class="methods-grid-container">
            <!-- 登录方式网格布局 -->
            <div class="methods-grid">
              <!-- 第一行第一列：账号密码 -->
              <div class="method-grid-item" v-if="profile.loginMethods[0]">
                <div class="method-content-single-line">
                  <div class="method-info-single-line">
                    <span class="method-type">{{ profile.loginMethods[0].type }}</span>
                    <span class="method-value">{{ profile.loginMethods[0].value }}</span>
                  </div>
                  <div class="method-actions">
                    <span
                        class="method-status"
                        :class="{
                          'status-bound': profile.loginMethods[0].isBound,
                          'status-unbound': !profile.loginMethods[0].isBound
                        }"
                    >
                      {{ profile.loginMethods[0].status }}
                    </span>
                    <el-button
                        v-if="profile.loginMethods[0].type === '账号密码' && !profile.loginMethods[0].isBound"
                        type="primary"
                        link
                        size="small"
                        @click="handleAction('set', profile.loginMethods[0])"
                    >
                      设置
                    </el-button>
                    <el-button
                        v-else-if="profile.loginMethods[0].type === '账号密码' && profile.loginMethods[0].isBound"
                        type="primary"
                        link
                        size="small"
                        @click="handleAction('changePassword', profile.loginMethods[0])"
                    >
                      修改密码
                    </el-button>
                  </div>
                </div>
              </div>

              <!-- 第一行第二列：微信 -->
              <div class="method-grid-item" v-if="profile.loginMethods[1]">
                <div class="method-content-single-line">
                  <div class="method-info-single-line">
                    <span class="method-type">{{ profile.loginMethods[1].type }}</span>
                    <span class="method-value">{{ profile.loginMethods[1].value }}</span>
                  </div>
                  <div class="method-actions">
                    <span
                        class="method-status"
                        :class="{
                          'status-bound': profile.loginMethods[1].isBound,
                          'status-unbound': !profile.loginMethods[1].isBound
                        }"
                    >
                      {{ profile.loginMethods[1].status }}
                    </span>
                  </div>
                </div>
              </div>

              <!-- 第二行第一列：登录手机 -->
              <div class="method-grid-item" v-if="profile.loginMethods[2]">
                <div class="method-content-single-line">
                  <div class="method-info-single-line">
                    <span class="method-type">{{ profile.loginMethods[2].type }}</span>
                    <span class="method-value">{{ profile.loginMethods[2].value }}</span>
                  </div>
                  <div class="method-actions">
                    <span
                        class="method-status"
                        :class="{
                          'status-bound': profile.loginMethods[2].isBound,
                          'status-unbound': !profile.loginMethods[2].isBound
                        }"
                    >
                      {{ profile.loginMethods[2].status }}
                    </span>
<!--                    <el-button-->
<!--                        v-if="profile.loginMethods[2].type === '登录手机' && profile.loginMethods[2].isBound"-->
<!--                        type="primary"-->
<!--                        link-->
<!--                        size="small"-->
<!--                        @click="handleAction('modify', profile.loginMethods[2])"-->
<!--                    >-->
<!--                      修改-->
<!--                    </el-button>-->
                  </div>
                </div>
              </div>

              <!-- 第二行第二列：空 -->
              <div class="method-grid-item empty-item"></div>
            </div>
          </div>
        </div>

        <!-- 底部描述区域 -->
        <div class="section description-section">
          <div class="description-content">
            <p class="description-text">
              为了保护您的账号安全，建议您定期修改密码，并绑定多种登录方式。
              如有任何问题，请联系客服人员。
            </p>
          </div>
        </div>
      </el-card>
    </div>

    <!-- 修改密码对话框 -->
    <el-dialog
        v-model="showPasswordDialog"
        title="修改密码"
        width="500px"
        :close-on-click-modal="false"
        :close-on-press-escape="false"
        :show-close="false"
        class="password-dialog"
    >
      <PasswordUpdateDialog
          @success="handlePasswordChangeSuccess"
          @cancel="closePasswordDialog"
      />
    </el-dialog>

    <!-- 修改昵称对话框 -->
    <el-dialog
        v-model="showNicknameDialog"
        title="修改昵称"
        width="400px"
        :close-on-click-modal="false"
        :close-on-press-escape="false"
        class="nickname-dialog"
    >
      <div class="nickname-form">
        <el-form>
          <el-form-item label="新昵称">
            <el-input
                v-model="newNickname"
                placeholder="请输入新昵称"
                maxlength="20"
                show-word-limit
            />
          </el-form-item>
        </el-form>
        <div class="dialog-actions">
          <el-button @click="closeNicknameDialog">取消</el-button>
          <el-button type="primary" @click="handleNicknameUpdate">确认</el-button>
        </div>
      </div>
    </el-dialog>

    <!-- 头像上传对话框 -->
    <el-dialog
        v-model="showAvatarDialog"
        title="更换头像"
        width="500px"
        :close-on-click-modal="false"
        class="avatar-dialog"
    >
      <div class="avatar-upload-form">
        <div class="upload-area">
          <!-- 预览区域 -->
          <div v-if="avatarPreviewUrl" class="preview-area">
            <img :src="avatarPreviewUrl" alt="头像预览" class="preview-image" />
            <div class="preview-text">预览</div>
          </div>

          <!-- 上传区域 -->
          <div class="upload-section">
            <el-upload
                drag
                :auto-upload="false"
                :show-file-list="false"
                :on-change="handleAvatarChange"
                accept=".jpg,.jpeg,.png,.gif,.bmp,.webp"
                class="avatar-uploader"
            >
              <div class="upload-content">
                <el-icon class="el-icon--upload"><upload-filled /></el-icon>
                <div class="el-upload__text">
                  将文件拖到此处，或<em>点击选择</em>
                </div>
                <div class="el-upload__tip">
                  支持 JPG、PNG、GIF、BMP、WebP 格式，大小不超过10MB
                </div>
              </div>
            </el-upload>
          </div>
        </div>

        <div class="dialog-actions">
          <el-button @click="closeAvatarDialog" :disabled="avatarUploading">取消</el-button>
          <el-button
              type="primary"
              @click="uploadAvatar"
              :loading="avatarUploading"
              :disabled="!avatarFile"
          >
            {{ avatarUploading ? '上传中...' : '确认上传' }}
          </el-button>
        </div>
      </div>
    </el-dialog>

    <!-- 修改手机对话框 -->
    <el-dialog
        v-model="showChangePhoneDialog"
        title="修改绑定手机"
        width="500px"
        :close-on-click-modal="false"
        :close-on-press-escape="false"
        class="change-phone-dialog"
    >
      <div class="change-phone-form">
        <!-- 第一步：验证旧手机 -->
        <div v-if="changePhoneStep === 1" class="step-content">
          <div class="step-title">第一步：验证当前手机</div>
          <div class="current-phone-info">
            <p>当前绑定的手机号：{{ maskedCurrentPhone }}</p>
          </div>
          <el-form>
            <el-form-item label="验证码">
              <div class="verify-code-input">
                <el-input
                    v-model="oldPhoneVerifyCode"
                    placeholder="请输入收到的验证码"
                    maxlength="6"
                />
                <el-button
                    type="primary"
                    :disabled="oldPhoneCodeCooldown > 0"
                    @click="sendOldPhoneCode"
                >
                  {{ oldPhoneCodeCooldown > 0 ? `${oldPhoneCodeCooldown}秒后重新获取` : '获取验证码' }}
                </el-button>
              </div>
            </el-form-item>
          </el-form>
          <div class="dialog-actions">
            <el-button @click="closeChangePhoneDialog">取消</el-button>
            <el-button type="primary" @click="verifyOldPhone">下一步</el-button>
          </div>
        </div>

        <!-- 第二步：绑定新手机 -->
        <div v-if="changePhoneStep === 2" class="step-content">
          <div class="step-title">第二步：绑定新手机</div>
          <el-form>
            <el-form-item label="新手机号">
              <el-input
                  v-model="newPhone"
                  placeholder="请输入新手机号"
                  maxlength="11"
              />
            </el-form-item>
            <el-form-item label="验证码">
              <div class="verify-code-input">
                <el-input
                    v-model="newPhoneVerifyCode"
                    placeholder="请输入验证码"
                    maxlength="6"
                />
                <el-button
                    type="primary"
                    :disabled="newPhoneCodeCooldown > 0 || !newPhone"
                    @click="sendNewPhoneCode"
                >
                  {{ newPhoneCodeCooldown > 0 ? `${newPhoneCodeCooldown}秒后重新获取` : '获取验证码' }}
                </el-button>
              </div>
            </el-form-item>
          </el-form>
          <div class="dialog-actions">
            <el-button @click="changePhoneStep = 1">上一步</el-button>
            <el-button type="primary" @click="confirmChangePhone">确认修改</el-button>
          </div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script setup>
import { ref, onMounted } from 'vue'
import request from '@/utils/request'
import { ElMessage } from 'element-plus'
import { useRouter } from 'vue-router'
import PasswordUpdateDialog from '@/components/PasswordUpdateDialog.vue'
import { eventBus } from '@/utils/eventBus'

const router = useRouter()
const profile = ref({
  avatar: '',
  nickname: '',
  username: '',
  userType: '',
  userLevel: '',
  email: '-',
  phone: '-',
  hasPassword: false,
  hasWechatBind: false,
  loginMethods: []
})

const loading = ref(false)
const showPasswordDialog = ref(false)
const showNicknameDialog = ref(false)
const newNickname = ref('')

// 修改手机号相关
const showChangePhoneDialog = ref(false)
const changePhoneStep = ref(1)
const oldPhoneVerifyCode = ref('')
const newPhone = ref('')
const newPhoneVerifyCode = ref('')
const oldPhoneCodeCooldown = ref(0)
const newPhoneCodeCooldown = ref(0)
const maskedCurrentPhone = ref('')

// 头像上传相关
const showAvatarDialog = ref(false)
const avatarFile = ref(null)
const avatarUploading = ref(false)
const avatarPreviewUrl = ref('')

// 默认头像
const defaultAvatar = ref('https://cube.elemecdn.com/3/7c/3ea6beec64369c2642b92c6726f1epng.png')

// 加载用户信息
const loadUserProfile = async () => {
  loading.value = true
  try {
    const response = await request.get('/user/profile')
    if (response.code === '200') {
      profile.value = response.data
      newNickname.value = profile.value.nickname
    } else {
      ElMessage.error(response.message || '获取用户信息失败')
    }
  } catch (error) {
    console.error('获取用户信息失败:', error)
  } finally {
    loading.value = false
  }
}

// 处理头像点击
const handleAvatarClick = () => {
  showAvatarDialog.value = true
}

// 处理文件选择
const handleFileChange = (file) => {
  avatarFile.value = file
  // 创建预览URL
  const reader = new FileReader()
  reader.onload = (e) => {
    avatarPreviewUrl.value = e.target.result
  }
  reader.readAsDataURL(file)
}

// 头像上传变化处理
const handleAvatarChange = (uploadFile) => {
  const file = uploadFile.raw
  if (!file) return

  // 验证文件类型
  const validTypes = ['image/jpeg', 'image/jpg', 'image/png', 'image/gif', 'image/bmp', 'image/webp']
  const isImage = validTypes.includes(file.type)
  const isLt10M = file.size / 1024 / 1024 < 10

  if (!isImage) {
    ElMessage.error('请选择图片文件（JPEG、PNG、GIF、BMP、WebP）')
    return
  }
  if (!isLt10M) {
    ElMessage.error('图片大小不能超过10MB')
    return
  }

  handleFileChange(file)
}

// 上传头像
const uploadAvatar = async () => {
  if (!avatarFile.value) {
    ElMessage.error('请选择要上传的图片')
    return
  }

  avatarUploading.value = true
  try {
    const formData = new FormData()
    formData.append('file', avatarFile.value)

    const response = await request.post('/user/update-avatar', formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    })

    if (response.code === '200') {
      // ElMessage.success('头像更新成功')
      profile.value.avatar = response.data
      showAvatarDialog.value = false
      avatarFile.value = null
      avatarPreviewUrl.value = ''

      // 发送头像更新事件
      eventBus.emit('user-profile-updated', {
        type: 'avatar',
        data: response.data
      })

      // 重新加载用户信息以确保数据一致
      await loadUserProfile()
    } else {
      ElMessage.error(response.message || '头像上传失败')
    }
  } catch (error) {
    console.error('上传头像失败:', error)
    ElMessage.error('头像上传失败，请稍后重试')
  } finally {
    avatarUploading.value = false
  }
}

// 关闭头像对话框
const closeAvatarDialog = () => {
  showAvatarDialog.value = false
  avatarFile.value = null
  avatarPreviewUrl.value = ''
}

// 打开修改手机对话框
const openChangePhoneDialog = () => {
  showChangePhoneDialog.value = true
  changePhoneStep.value = 1
  oldPhoneVerifyCode.value = ''
  newPhone.value = ''
  newPhoneVerifyCode.value = ''

  // 显示脱敏的当前手机号
  maskedCurrentPhone.value = profile.value.phone || '-'
}

// 关闭修改手机对话框
const closeChangePhoneDialog = () => {
  showChangePhoneDialog.value = false
  changePhoneStep.value = 1
  oldPhoneVerifyCode.value = ''
  newPhone.value = ''
  newPhoneVerifyCode.value = ''
  oldPhoneCodeCooldown.value = 0
  newPhoneCodeCooldown.value = 0
}

// 发送旧手机验证码
const sendOldPhoneCode = async () => {
  try {
    const response = await request.post('/user/send-change-phone-code', {
      phoneType: 'old'
      // 不再传递手机号，后端会通过userId自动获取
    })

    if (response.code === '200') {
      ElMessage.success('验证码发送成功')
      startOldPhoneCooldown()
    } else {
      ElMessage.error(response.message || '验证码发送失败')
    }
  } catch (error) {
    console.error('发送验证码失败:', error)
    ElMessage.error('验证码发送失败')
  }
}

// 发送新手机验证码
const sendNewPhoneCode = async () => {
  if (!newPhone.value.trim()) {
    ElMessage.error('请输入新手机号')
    return
  }

  if (!newPhone.value.match(/^1[3-9]\d{9}$/)) {
    ElMessage.error('手机号格式不正确')
    return
  }

  try {
    const response = await request.post('/user/send-change-phone-code', {
      phoneType: 'new',
      newPhone: newPhone.value.trim() // 只传递新手机号
    })

    if (response.code === '200') {
      ElMessage.success('验证码发送成功')
      startNewPhoneCooldown()
    } else {
      ElMessage.error(response.message || '验证码发送失败')
    }
  } catch (error) {
    console.error('发送验证码失败:', error)
    ElMessage.error('验证码发送失败')
  }
}

// 验证旧手机
const verifyOldPhone = async () => {
  if (!oldPhoneVerifyCode.value.trim()) {
    ElMessage.error('请输入验证码')
    return
  }

  try {
    const response = await request.post('/user/verify-old-phone', {
      verifyCode: oldPhoneVerifyCode.value.trim()
    })

    if (response.code === '200') {
      ElMessage.success('验证成功')
      changePhoneStep.value = 2
    } else {
      ElMessage.error(response.message || '验证失败')
    }
  } catch (error) {
    console.error('验证旧手机失败:', error)
    ElMessage.error('验证失败')
  }
}

// 确认修改手机
const confirmChangePhone = async () => {
  if (!newPhone.value.trim()) {
    ElMessage.error('请输入新手机号')
    return
  }

  if (!newPhoneVerifyCode.value.trim()) {
    ElMessage.error('请输入验证码')
    return
  }

  try {
    const response = await request.post('/user/change-phone', {
      newPhone: newPhone.value.trim(),
      newPhoneVerifyCode: newPhoneVerifyCode.value.trim()
    })

    if (response.code === '200') {
      ElMessage.success('手机号修改成功')
      closeChangePhoneDialog()
      // 重新加载用户信息
      await loadUserProfile()
    } else {
      ElMessage.error(response.message || '修改失败')
    }
  } catch (error) {
    console.error('修改手机号失败:', error)
    ElMessage.error('修改失败')
  }
}

// 倒计时计时器
const startOldPhoneCooldown = () => {
  oldPhoneCodeCooldown.value = 60
  const timer = setInterval(() => {
    oldPhoneCodeCooldown.value--
    if (oldPhoneCodeCooldown.value <= 0) {
      clearInterval(timer)
    }
  }, 1000)
}

const startNewPhoneCooldown = () => {
  newPhoneCodeCooldown.value = 60
  const timer = setInterval(() => {
    newPhoneCodeCooldown.value--
    if (newPhoneCodeCooldown.value <= 0) {
      clearInterval(timer)
    }
  }, 1000)
}


const handleAction = (action, method) => {
  switch (action) {
    case 'set':
      ElMessage.info('功能开发中...')
      break
    case 'modify':
      // 修改手机号
      openChangePhoneDialog()
      break
    case 'unbind':
      ElMessage.info('功能开发中...')
      break
    case 'bind':
      ElMessage.info('功能开发中...')
      break
    case 'changePassword':
      showPasswordDialog.value = true
      break
    case 'editNickname':
      showNicknameDialog.value = true
      break
  }
}

const getAvatarUrl = () => {
  return profile.value.avatar || defaultAvatar.value
}

const closePasswordDialog = () => {
  showPasswordDialog.value = false
}

const closeNicknameDialog = () => {
  showNicknameDialog.value = false
  newNickname.value = profile.value.nickname
}

const handlePasswordChangeSuccess = () => {
  showPasswordDialog.value = false
  ElMessage.success('密码修改成功，请重新登录')

  setTimeout(() => {
    localStorage.removeItem('token')
    localStorage.removeItem('userInfo')

    localStorage.removeItem('auth_token');
    eventBus.clearUser(); // 使用 eventBus 清除用户
    router.push('/login')
  }, 1500)
}

const handleNicknameUpdate = async () => {
  if (!newNickname.value.trim()) {
    ElMessage.error('昵称不能为空')
    return
  }

  if (newNickname.value === profile.value.nickname) {
    ElMessage.info('昵称未发生变化')
    closeNicknameDialog()
    return
  }

  try {
    const response = await request.put('/user/update-nickname', {
      nickname: newNickname.value.trim()
    })

    if (response.code === '200') {
      // ElMessage.success('昵称修改成功')
      profile.value.nickname = newNickname.value.trim()
      closeNicknameDialog()

      // 发送昵称更新事件
      eventBus.emit('user-profile-updated', {
        type: 'nickname',
        data: newNickname.value.trim()
      })
    } else {
      ElMessage.error(response.message || '昵称修改失败')
    }
  } catch (error) {
    console.error('修改昵称失败:', error)
    ElMessage.error('昵称修改失败，请稍后重试')
  }
}

onMounted(() => {
  loadUserProfile()
})
</script>

<style scoped>
/*对话框相关样式 */
.password-dialog {
  :deep(.el-dialog__header) {
    border-bottom: 1px solid #e4e7ed;
    padding: 15px 20px;
    margin: 0;
  }

  :deep(.el-dialog__title) {
    font-size: 16px;
    font-weight: 600;
    color: #303133;
  }

  :deep(.el-dialog__body) {
    padding: 20px;
  }
}

.nickname-dialog {
  :deep(.el-dialog__body) {
    padding: 20px;
  }
}

.nickname-form {
  .dialog-actions {
    display: flex;
    justify-content: flex-end;
    gap: 12px;
    margin-top: 20px;
  }
}

/* 编辑按钮样式 */
.edit-btn {
  padding: 4px;
  margin-left: 8px;
}

.edit-btn .el-icon {
  font-size: 14px;
}

/* 其他原有样式保持不变 */
.user-profile {
  padding: 20px;
  max-width: 900px;
  margin: 0 auto;
}

.profile-header {
  margin-bottom: 24px;
}

.profile-header h2 {
  margin: 0;
  color: #303133;
  font-size: 24px;
  font-weight: 500;
}

.profile-content {
  display: flex;
  flex-direction: column;
}

/* 主卡片样式 */
.main-card {
  border-radius: 8px;
  border: 1px solid #e4e7ed;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
}

:deep(.el-card__body) {
  padding: 0;
}

/* 区域通用样式 */
.section {
  padding: 24px;
}

.section-header {
  margin-bottom: 20px;
}

.section-title {
  margin: 0;
  color: #303133;
  font-size: 16px;
  font-weight: 600;
}

.section-title-with-subtitle {
  display: flex;
  align-items: center;
  gap: 12px;
}

.section-subtitle {
  color: #909399;
  font-size: 12px;
  font-weight: normal;
}

/* 分隔线 */
.section-divider {
  height: 1px;
  background-color: #f0f0f0;
  margin: 0;
}

/* 基本信息区域 */
.basic-info-section {
  background: #fff;
}

.basic-info-content {
  display: flex;
  gap: 30px;
  align-items: flex-start;
}

.avatar-area {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;
  flex-shrink: 0;
  margin-top: 20px;
  width: 120px;
}

.user-avatar {
  border: 2px solid #f0f0f0;
}

.avatar-actions {
  display: flex;
  align-items: center;
}

.info-area {
  flex: 1;
}

.info-grid {
  display: flex;
  flex-direction: column;
  gap: 0;
}

.info-row {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 40px;
  padding: 16px 0;
  border-bottom: 1px solid #f5f7fa;
}

.info-row:last-child {
  border-bottom: none;
}

.info-item {
  display: flex;
  align-items: center;
  min-height: 32px;
}

.info-label {
  width: 80px;
  color: #606266;
  font-size: 14px;
  margin-right: 16px;
  flex-shrink: 0;
  font-weight: 500;
}

.info-value {
  color: #303133;
  font-size: 14px;
  flex: 1;
}

.info-with-action {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
}

/* 添加用户等级标签样式 */
.user-level-tag {
  border-radius: 4px;
  font-size: 12px;
  font-weight: 500;
  padding: 4px 8px;
}

/* 确保标签与原有布局兼容 */
.info-value .user-level-tag {
  margin: 0;
}

/* 登录方式区域 */
.login-methods-section {
  background: #fff;
}

.methods-grid-container {
  margin-left: 150px; /* 与头像区域对齐 */
}

.methods-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-template-rows: auto auto;
  gap: 10px 40px;
}

.method-grid-item {
  padding: 16px 0;
}

.empty-item {
  border: none;
  background: transparent;
}

.method-content-single-line {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 12px;
}

.method-info-single-line {
  display: flex;
  align-items: center;
  gap: 8px;
  flex: 1;
}

.method-type {
  color: #303133;
  font-size: 14px;
  font-weight: 500;
  min-width: 60px;
}

.method-value {
  color: #606266;
  font-size: 12px;
}

.method-actions {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-shrink: 0;
}

.method-status {
  font-size: 12px;
  min-width: 40px;
  text-align: center;
}

.status-bound {
  color: #67c23a;
}

.status-unbound {
  color: #909399;
}

/* 描述区域 */
.description-section {
  background: #fafafa;
  border-top: 1px solid #f0f0f0;
}

.description-content {
  text-align: center;
}

.description-text {
  margin: 0;
  color: #909399;
  font-size: 12px;
  line-height: 1.5;
}

/* 头像上传对话框样式 */
.avatar-dialog {
  :deep(.el-dialog__body) {
    padding: 20px;
  }
}

.avatar-upload-form {
  .upload-area {
    display: flex;
    gap: 20px;
    margin-bottom: 20px;
  }

  .preview-area {
    flex: 0 0 120px;
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  .preview-image {
    width: 120px;
    height: 120px;
    border-radius: 50%;
    object-fit: cover;
    border: 2px solid #f0f0f0;
  }

  .upload-section {
    flex: 1;
  }

  .avatar-uploader {
    :deep(.el-upload) {
      width: 100%;
    }

    :deep(.el-upload-dragger) {
      width: 100%;
      height: 180px;
      border: 2px dashed #dcdfe6;
      border-radius: 6px;
      cursor: pointer;
      position: relative;
      overflow: hidden;
      transition: border-color 0.3s;

      &:hover {
        border-color: #409eff;
      }
    }

    .upload-content {
      padding: 20px;
      text-align: center;
    }

    .el-icon--upload {
      font-size: 48px;
      color: #c0c4cc;
      margin-bottom: 16px;
    }

    .el-upload__text {
      color: #606266;
      font-size: 14px;
      margin-bottom: 8px;

      em {
        color: #409eff;
        font-style: normal;
      }
    }

    .el-upload__tip {
      color: #909399;
      font-size: 12px;
      line-height: 1.5;
    }
  }

  .dialog-actions {
    display: flex;
    justify-content: flex-end;
    gap: 12px;
    margin-top: 20px;
  }
}

.avatar-hint {
  margin-top: 8px;
  text-align: center;
}

.hint-text {
  color: #409eff;
  font-size: 12px;
  cursor: pointer;
}

/* 为头像添加点击效果 */
.avatar-area {
  cursor: pointer;
  transition: opacity 0.3s;

  &:hover {
    opacity: 0.8;
  }
}

.user-avatar {
  transition: transform 0.3s;

  &:hover {
    transform: scale(1.05);
  }
}

.preview-area {
  position: relative;
}

.preview-text {
  position: absolute;
  bottom: -25px;
  left: 50%;
  transform: translateX(-50%);
  color: #909399;
  font-size: 12px;
  white-space: nowrap;
}

/* 修改手机对话框样式 */
.change-phone-dialog {
  :deep(.el-dialog__body) {
    padding: 20px;
  }
}

.change-phone-form {
  .step-content {
    .step-title {
      font-size: 16px;
      font-weight: 600;
      color: #303133;
      margin-bottom: 20px;
      padding-bottom: 12px;
      border-bottom: 1px solid #f0f0f0;
    }

    .current-phone-info {
      background: #f8f9fa;
      padding: 12px 16px;
      border-radius: 6px;
      margin-bottom: 20px;

      p {
        margin: 0;
        color: #606266;
        font-size: 14px;

        &:first-child {
          font-weight: 500;
          color: #303133;
        }
      }
    }

    .verify-code-input {
      display: flex;
      gap: 12px;
      align-items: flex-start;

      .el-input {
        flex: 1;
      }

      .el-button {
        flex-shrink: 0;
        min-width: 120px;
      }
    }

    .dialog-actions {
      display: flex;
      justify-content: flex-end;
      gap: 12px;
      margin-top: 24px;
      padding-top: 16px;
      border-top: 1px solid #f0f0f0;
    }
  }
}

/* 表单标签样式 */
.change-phone-form {
  :deep(.el-form-item__label) {
    font-weight: 500;
    color: #606266;
  }

  :deep(.el-input__inner) {
    border-radius: 4px;
  }

  :deep(.el-button) {
    border-radius: 4px;
    font-weight: 500;
  }
}

/* 步骤指示器样式（可选，如果需要显示步骤进度） */
.step-indicator {
  display: flex;
  justify-content: center;
  margin-bottom: 24px;

  .step-item {
    display: flex;
    flex-direction: column;
    align-items: center;
    position: relative;

    &:not(:last-child)::after {
      content: '';
      position: absolute;
      top: 12px;
      right: -60px;
      width: 60px;
      height: 1px;
      background: #e4e7ed;
    }

    .step-number {
      width: 24px;
      height: 24px;
      border-radius: 50%;
      background: #f0f0f0;
      color: #909399;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 12px;
      font-weight: 600;
      margin-bottom: 8px;
      transition: all 0.3s ease;
    }

    .step-text {
      font-size: 12px;
      color: #909399;
      white-space: nowrap;
    }

    &.active {
      .step-number {
        background: #409eff;
        color: white;
      }

      .step-text {
        color: #409eff;
        font-weight: 500;
      }
    }

    &.completed {
      .step-number {
        background: #67c23a;
        color: white;
      }

      .step-text {
        color: #67c23a;
      }
    }
  }
}

/* 验证码输入框的特殊样式 */
.verify-code-input {
  :deep(.el-input__inner) {
    text-align: center;

  }
}

/* 手机号输入验证状态 */
.phone-input {
  :deep(.el-input__inner) {
    font-family: monospace;
    letter-spacing: 1px;
  }

  &.valid {
    :deep(.el-input__inner) {
      border-color: #67c23a;
    }
  }

  &.invalid {
    :deep(.el-input__inner) {
      border-color: #f56c6c;
    }
  }
}

/* 加载状态 */
.dialog-loading {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(255, 255, 255, 0.8);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 10;
  border-radius: 6px;
}

/* 成功/错误消息样式 */
.verification-message {
  padding: 8px 12px;
  border-radius: 4px;
  margin-bottom: 16px;
  font-size: 13px;

  &.success {
    background: #f0f9ff;
    color: #409eff;
    border: 1px solid #d9ecff;
  }

  &.error {
    background: #fef0f0;
    color: #f56c6c;
    border: 1px solid #fde2e2;
  }

  &.warning {
    background: #fdf6ec;
    color: #e6a23c;
    border: 1px solid #faecd8;
  }
}

/* 响应式设计 */
@media (max-width: 768px) {
  .user-profile {
    padding: 16px;
  }

  .section {
    padding: 16px;
  }

  .basic-info-content {
    flex-direction: column;
    gap: 20px;
  }

  .avatar-area {
    width: 100%;
    flex-direction: row;
    justify-content: center;
    gap: 20px;
  }

  .info-row {
    grid-template-columns: 1fr;
    gap: 16px;
    padding: 12px 0;
  }

  .info-item {
    min-height: 28px;
  }

  .method-row {
    flex-direction: column;
    gap: 16px;
  }

  .method-content {
    flex-direction: column;
    align-items: flex-start;
    gap: 8px;
  }

  .method-actions {
    align-self: flex-end;
  }

  .section-title-with-subtitle {
    flex-direction: column;
    align-items: flex-start;
    gap: 4px;
  }

  .avatar-upload-form .upload-area {
    flex-direction: column;
  }

  .preview-area {
    align-self: center;
  }

  .change-phone-dialog {
    :deep(.el-dialog) {
      width: 90% !important;
      max-width: 400px;
    }
  }

  .change-phone-form {
    .step-content {
      .verify-code-input {
        flex-direction: column;

        .el-button {
          min-width: 100%;
          margin-top: 8px;
        }
      }

      .dialog-actions {
        flex-direction: column;

        .el-button {
          width: 100%;
          margin: 4px 0;
        }
      }
    }
  }
}

/* 卡片内部样式调整 */
:deep(.el-card) {
  border-radius: 8px;
  border: 1px solid #e4e7ed;
}

:deep(.el-card__body) {
  padding: 0;
}
</style>